import './setupUserSettings';
import { setupResolution } from './setupResolution';
import { setupConfig } from './setupConfig';
import { registerApis } from './apiRegistration';

setupResolution();
setupConfig();
registerApis();
